import React, { Component } from "react";
import errorcodes from "../errorcodes";
import errormessages from "../../Messages/ErrorMessages";
import componentsStrings from "../../Messages/Components";

import "../../css/colors.css"
import "../../css/texts.css"
import connections from "../../connections";
import { Redirect } from "react-router-dom";
import { Col, Form, Row } from "react-bootstrap";
import texts from "../New/Texts";


class RecoverNew extends Component {
 
  state = {
    username: "",
    registrationpassword: "",
    userpassword: "",
    recoverenabled: false,
    recoverrmsg: "",
    passwordUpdated: false,
    redirectToLogin: false
  };

  componentDidMount() {
    this.setState({username: this.props.username, registrationpassword: this.props.password});
  }

  handlePasswordChange = event => {
    if(event.target.value === "") {
      this.setState({ recoverenabled: false });
    } else {
      this.setState({ recoverenabled: true });
    }

    this.setState({ userpassword: event.target.value, recoverrmsg: "" });
  };

  isDisabled = () => {
    if (
      this.state.username.length === 0 ||
      this.state.userpassword.length === 0
    ) {
      return true;
    } else {
      return false;
    }
  };
  
  handleSubmit = event => {
    this.setState({ recoverrmsg: ""});

    event.preventDefault();
    let url = connections.sdkurl;
    let mythis = this;
    fetch(url + "/AEYEAppServer/v1/UserRepository/recover", {
      method: "POST",
      body: JSON.stringify({
        logonid: this.state.username,
        registrationpassword: this.state.registrationpassword,
        userpassword: this.state.userpassword
      })
    })
      .then(response => response.json())
      .then(data => {
        if (data.errorcode !== errorcodes.errorOK) {
          this.setState({recoverrmsg: errormessages.recoverform_failToRecover});
        } else {
          this.setState({passwordUpdated: true, recoverrmsg: ""});
        }
      }).catch(function(error) {
        mythis.setState({recoverrmsg: errormessages.recoverform_failToRecover});
      });
  };
  
  redirectToLogin = () => {
    this.setState({ redirectToLogin: true });
  };

  renderRedirect = () => {
    if (this.state.redirectToLogin === true) {
      return <Redirect to="/" />;
    }
  };

  render() {
    return (
      <React.Fragment>
        {this.renderRedirect()}
        {this.getMainWindow()}
      </React.Fragment>
      );
  }

  getMainWindow() {

    if(this.state.passwordUpdated === true) {

      return (
        <React.Fragment>
          <div className="login-bg">
  
            <Col md={6} style={{paddingTop: '24vh'}}>
              
              <Row className="pb-4">
                <Col align="center">
                  <img className="login-logo" src={"/logo_new.png"}></img>
                </Col>
              </Row>     
  
              <Row className="pb-5">
                <Col align="center">
  
                  <div className="text white lh44 fs40"> {texts.recoverscreen_updated_title} </div>
                  <div className="text gray_3 lh24 fs20 pt-4"> {texts.recoverscreen_updated_text} </div>

                </Col>            
              </Row> 
              
              <Row>
                <Col align="center">

                  <Form.Group className="pwd-container pb-3">

                    <button className="pwd-container btn btn-primary button" type="button" onClick={this.redirectToLogin}>{componentsStrings.button_login}</button>

                  </Form.Group>
                    
                </Col>  
              </Row> 
            
            </Col>

          </div>
        </React.Fragment>
      );
    }
    else {

      return (
        <React.Fragment>

          <div className="login-bg">
            <Col md={6} style={{paddingTop: '24vh'}}>

              <Row className="pb-4">
                <Col align="center">
                  <img className="login-logo" src={"/logo_new.png"}></img>
                </Col>
              </Row>     

              <Row className="pb-5">
                <Col align="center">
                  <div className="text white lh44 fs40"> New password </div>
                </Col>            
              </Row> 

              <Row>
                <Col align="center">

                    <Form onSubmit={this.handleSubmit}>
    
                      <Form.Group className="pwd-container pb-3">
                      
                        <input  id="recoverform_email" class="login-input" type="text" value={this.state.username} disabled = {true}/>

                      </Form.Group>

                      <Form.Group className="pwd-container pb-3">

                        <input  id="recoverform_password" class="login-input" type="password" placeholder={componentsStrings.textfiled_placeholder_createpassword} onChange={this.handlePasswordChange}/>
                        <div align="left" class="gray_3"> {texts.recoverscreen_request_password} </div>

                      </Form.Group>

                      <Form.Group className="pwd-container pb-3">

                        <button disabled={!this.state.recoverenabled || this.isDisabled()} class="pwd-container btn btn-primary button" type="submit"> {componentsStrings.button_submit} </button>
                        
                        {this.state.recoverrmsg != '' && <div align="left" >
                          <img src={"/exclamation_mark.png"} style={{position: 'unset'}}/>
                          <div class="d-md-inline-flex pt-1 pl-1 red " id="staticEmail" > {this.state.recoverrmsg} </div>
                        </div>}

                      </Form.Group>
                      
                    </Form>

                </Col>  
              </Row> 

            </Col>
          </div>

        </React.Fragment>
      );
    }

  }

}

export default RecoverNew;
